import React from 'react';
import { DATALAYER_FIELD, DATALAYER_EVENT } from '../../client/analytics/dataLayerConstants';
export var HELP_URL = 'http://help.milanote.com';
export var MARKETING_URL = 'https://milanote.com';
export var SERVICE_STATUS_URL = 'http://status.milanote.com/';
export var REGISTER_PAGE_URL = '/register';
export var APP_BASE_URL = function () {
  if (typeof document === 'undefined') {
    // serverside render - use the config object
    // (it's not available to the client)
    var config = require('../../../config');
    return config.appUrl;
  }

  // clientside render - server provides a meta tag to use
  var meta = document.querySelector('meta[name="milanote-app-url"]');
  if (meta) {
    return meta.getAttribute('content');
  }

  // fallback to hardcoded value if meta tag isn't present for some reason
  return 'https://app.milanote.com';
}();
export var LOGIN_PAGE_URL = "".concat(APP_BASE_URL, "/login");
export var REFERRAL_QUERY_PARAM = 'r';
export var REFERRAL_ALT_QUERY_PARAM = 'ref';
export var URL_ENCODINGS = {
  NEW_LINE: '%0A'
};
export var MILANOTE_EMAILS = {
  SUPPORT: 'support@milanote.com',
  INFO: 'info@milanote.com',
  FEEDBACK: 'feedback@milanote.com'
};
export var BLOG_NAV_LINKS = [{
  text: 'All stories',
  route: '/the-work'
}, {
  text: 'About Milanote',
  route: '/'
}];
export var DEFAULT_NAV_LINKS = [{
  text: 'Log in',
  route: LOGIN_PAGE_URL,
  className: 'Button secondary',
  trackClickEvent: DATALAYER_EVENT.CTA_CLICK,
  trackClickEventCategory: DATALAYER_FIELD.ACTION_CATEGORY.LOGIN
}, {
  text: /*#__PURE__*/React.createElement("span", null, "Sign up ", /*#__PURE__*/React.createElement("span", {
    className: "for-free"
  }, "for free")),
  route: REGISTER_PAGE_URL,
  className: 'Button register',
  trackClickEvent: DATALAYER_EVENT.CTA_CLICK,
  trackClickEventCategory: DATALAYER_FIELD.ACTION_CATEGORY.REGISTER
}];
export var REGISTER_PAGE_NAV_LINKS = [{
  text: 'Log in',
  route: LOGIN_PAGE_URL,
  className: 'Button secondary',
  trackClickEvent: DATALAYER_EVENT.CTA_CLICK,
  trackClickEventCategory: DATALAYER_FIELD.ACTION_CATEGORY.LOGIN
}];
export var BLOG_FEEDS = [{
  mimetype: 'application/json',
  url: "".concat(MARKETING_URL, "/the-work/feed.json")
}, {
  mimetype: 'application/rss+xml',
  url: "".concat(MARKETING_URL, "/the-work/feed.xml")
}];